import { IMasterclass } from '@/entities/masterclass/types';
import type { MasterclassSortKey } from '@/widgets/masterclasses/constants/sort-options';

export const getMasterclassReviewsCount = (masterclass: IMasterclass) =>
  masterclass.reviewsCount ?? masterclass.reviews?.length ?? 0;

export const getMasterclassPurchaseCount = (masterclass: IMasterclass) =>
  masterclass.purchaseCount ?? 0;

export const sortMasterclasses = (
  masterclasses: IMasterclass[],
  sortValue: MasterclassSortKey | string,
) => {
  if (sortValue === 'default') {
    return masterclasses;
  }

  return [...masterclasses].sort((a, b) => {
    switch (sortValue) {
      case 'priceASC':
        return a.finalPrice - b.finalPrice;
      case 'priceDSC':
        return b.finalPrice - a.finalPrice;
      case 'reviewsDSC':
        return (
          getMasterclassReviewsCount(b) - getMasterclassReviewsCount(a)
        );
      case 'purchasesDSC':
        return (
          getMasterclassPurchaseCount(b) - getMasterclassPurchaseCount(a)
        );
      default:
        return 0;
    }
  });
};
